import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';
import { AutomationPage } from './pages/AutomationPage';
import { ContactPage } from './pages/ContactPage';
import { CrmIntegrationsPage } from './pages/CrmIntegrationsPage';
import { HomePage } from './pages/HomePage';
import { LeadScoringPage } from './pages/LeadScoringPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mm2j470bqezq">
      <div className="flex min-h-full w-full flex-col bg-[#f8f7f3] text-[#172820]" data-id="element-1" data-mp="2mmvl6uoc8gbj">
        <SiteHeader data-id="element-2" data-mp="31b8lg3ugklbu" />
        <Routes data-id="element-3" data-mp="31bib1qblcqh0">
          <Route path="/" element={<HomePage data-id="element-5" data-mp="31cjog1g2xp1w" />} data-id="element-4" data-mp="31c9y2cr4hfvo" />
          <Route path="/services/crm-integrations" element={<CrmIntegrationsPage data-id="element-7" data-mp="2wi5l9cv6edmo" />} data-id="element-6" data-mp="2wjgqzi86lvgf" />
          <Route path="/services/automation" element={<AutomationPage data-id="element-9" data-mp="28sbad0uf2z52" />} data-id="element-8" data-mp="28te1n9vnj3li" />
          <Route path="/services/lead-scoring" element={<LeadScoringPage data-id="element-11" data-mp="23ut9zyugts8o" />} data-id="element-10" data-mp="23vuo6c6s2uum" />
          <Route path="/contact" element={<ContactPage data-id="element-13" data-mp="3ikr0s4yore8d" />} data-id="element-12" data-mp="3ijxpcqos80jw" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-15" data-mp="3ihv1ac76whht" />} data-id="element-14" data-mp="3ijfvu1ti80fo" />
        </Routes>
        <SiteFooter data-id="element-16" data-mp="3mkhmvvd9p66k" />
      </div>
    </BrowserRouter>;
}